export const ROLE_PERMISSIONS_QUERY_KEY = 'rolePermissions'
